import { extractPhoneNumber } from '../ReviewCombinedPersonalInformation/util';
import { trimJoinedStringWhitespace } from '../../core/util';
import { maskSsnForDisplay } from '../PersonalInformationSection/util';

export const trustSummaryLine2 = trust => {
  const { address } = trust || {};

  const { street1, street2, zip, city, state } = address || {};

  return [street1, street2, city, state, zip].filter(item => item).join(' / ');
};

export const trustSummaryLine1 = trust => {
  const { name, taxID, trustDate } = trust || {};

  return [name, maskSsnForDisplay(taxID), trustDate]
    .filter(item => item)
    .join(' / ');
};

export const trusteeSummaryLine1 = trustee => {
  const { name, residentialAddress } = trustee || {};

  const { firstName, middleName = '', lastName } = name || {};
  const { street1, street2, zip, city, state } = residentialAddress || {};

  // Midle initial might also be in there...
  const fullName = [firstName, middleName, lastName].join(' ');

  return [
    trimJoinedStringWhitespace(fullName),
    street1,
    street2,
    city,
    state,
    zip
  ]
    .filter(item => item)
    .join(' / ');
};

export const trusteeSummaryLine2 = trustee => {
  const { primaryEmailAddress: emailAddress, phones } = trustee || {};

  const phoneNumber = extractPhoneNumber(phones);

  return [emailAddress, phoneNumber].filter(item => item).join(' / ');
};

export const trusteeSummaryLine3 = trustee => {
  const { citizenship, taxID, dob } = trustee || {};

  return [
    dob,
    {
      US_CITIZEN: 'U.S. Citizen',
      RESIDENT_ALIEN: 'U.S. Resident Alien'
    }[citizenship] || citizenship,
    maskSsnForDisplay(taxID)
  ]
    .filter(item => item)
    .join(' / ');
};
